import React from 'react';

export const showAlert = (alertText:string) => {
  alert(alertText)
};

